// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar[data-v-60df51e0]{align-items:stretch;display:flex;flex-direction:column;flex-wrap:nowrap;height:100%;padding:0}.navbar__menu-wrapper[data-v-60df51e0]{flex:1 0 auto;position:relative}#navigation[data-v-60df51e0]{width:250px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
